import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const discountApi = createApi({
  reducerPath: "discountApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Discount"],

  endpoints: (builder) => ({
     
    getAllDiscountsByPlate: builder.query({
      query: (plateNumber) => ({
        url: `/Car/discounts/${plateNumber}`,
        method: "GET",
      }),
      providesTags: ["Discount"],
    }),

    addDiscount: builder.mutation({
      query: (body) => ({
        url: "/Car/add-discount",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Discount"],
    }),

    deactiveDiscount: builder.mutation({
      query: (id) => ({
        url: `/Car/discount/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Discount"],
    }),
  }),
});
 
export const {
  useGetAllDiscountsByPlateQuery, 
  useAddDiscountMutation,
  useDeactiveDiscountMutation,
} = discountApi;